export const COMMONPROPERTIES = {
    SKU: 'Sku',
    STORER_KEY : 'storerKey',
    FACILITY : 'facility',
    STORER : 'storer',
    SOURCE_KEY : 'sourceKey',
    ASN_KEY : 'receiptKey',
    UCC_NO : 'uccNo',
    COMMODITY : 'commodity',
    LOT:'lot',
    CHANNEL: 'channel',
    CHANNELID: 'channelID',
    DOCUMENT_TYPE : 'documentType',
    BREADCRUMB_LABEL: {
      SO: 'Shipment Order',
      ASN: 'ASN',
      PICKMANAGEMENT: 'Pick Management',
      SHIPREFERENCE: 'Ship Reference',
      TASK: 'Task',
      INVENTORYTRANSACTION: 'Inventory Transaction',
      WAVECONTROLDETAILS: 'Wave Control Details',
      COMMODITYDETAILS: 'Commodity Details',
    },
    DISPLAY_MODE: {
      EDIT: 'E',
      CREATE: 'C',
      VIEW: 'V',
    }
  };



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/models/common-fields.ts